import type { HTMLAttributes } from 'react'
export type ThemeImageSource = { light: string; dark: string }
type Props = { source: ThemeImageSource; alt: string; loading?: 'eager' | 'lazy' } & Pick<HTMLAttributes<HTMLSpanElement>, 'className'>
export function ThemeImage({ source, alt, loading = 'eager', className }: Props) {
  return <span className={className || 'theme-image'}><img src={source.light} alt={alt} loading={loading} decoding="async" /></span>
}
